var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67189 18.9437C14.7591 18.9437 18.8828 14.8199 18.8828 9.7327C18.8828 4.6455 14.7591 0.521753 9.67189 0.521753C4.58468 0.521753 0.460938 4.6455 0.460938 9.7327C0.460938 14.8199 4.58468 18.9437 9.67189 18.9437Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50391 10.3282L7.88587 12.7102L13.8408 6.75525",
    stroke: "#7956D8",
    strokeWidth: 1.41707,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightCircle);
export default __webpack_public_path__ + "static/media/lightCircle.83dc7f087f7ddea37a6cc4a77b8e88b5.svg";
export { ForwardRef as ReactComponent };